/**
 * @file
 * @author zhousheng
 */
import * as React from 'react';
import Empty from '../empty';
import { ConfigConsumer } from '../config-provider';
var renderEmpty = function renderEmpty(des) {
  return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var prefix = getPrefixCls('empty');
    return /*#__PURE__*/React.createElement(Empty, {
      className: "".concat(prefix, "-small"),
      hasImage: false,
      description: des
    });
  });
};
export default renderEmpty;